import * as util from '@/util';

const { deepFreeze } = util;

const stateFreezer =
  (reducer: AnyFixMe) => (state: AnyFixMe, action: AnyFixMe) =>
    deepFreeze(reducer(state, action));

export default stateFreezer;
